import { createAsyncThunk } from "@reduxjs/toolkit";
import { promocodesAPI } from "api/api/promoCodesApi/promoCodesApi";
import { GetPromocodesParams, GetPromocodesRes, GetPromocodesValidateError } from "api/api/promoCodesApi/types";
import { AxiosError } from "axios";

import { toast } from "react-toastify";

export const getPromocodesValidate = createAsyncThunk<
  GetPromocodesRes,
  GetPromocodesParams
>(
  `statuses/getPromocodesValidate`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await promocodesAPI.getPromocodesValidate(params);
      toast.success(`Промокод дает ${data.discount}% скидку`)
      return data;
    } catch (error: unknown) {
      console.log(error, 'error');
      const axiosError = error as AxiosError<GetPromocodesValidateError>;

      const message =
        axiosError.response?.data?.detail ||
        axiosError.response?.data?.title ||
        "Произошла ошибка при проверке промокода";

      toast.error(message);

      return rejectWithValue(message);
    }
  }
);